<template>
  <div class="bg_color">
    <top-header
      :type="6"
      :placeholder="'我要卖房'"
      :hasBorder="true"
      :bgColor="'#fff'"
      fontSize="0.32rem"
    />
    <div class="top_banner">
      <img src="@/assets/img/strictSelection/detail_img.png" alt="" />
      <div class="main">
        <van-form @submit="onSubmit" validate-trigger="onSubmit">
          <h3>填写房屋/用户信息<van-icon name="question" color="#BEBEBE" /></h3>
          <van-field
            size="large"
            required
            v-model="form.userName"
            label="姓名"
            placeholder="请输入姓名"
          />
          <van-field
            size="large"
            required
            v-model="form.userCardno"
            label="身份证"
            placeholder="请输入身份证"
          />
          <van-field
            size="large"
            required
            v-model="form.userPhone"
            label="联系方式"
            placeholder="请输入联系方式"
          />

          <van-field
            size="large"
            required
            v-model="form.houseCertificate"
            label="房屋证号"
            placeholder="请输入房屋证号"
          />
        </van-form>
        <div style="height:0.2rem"></div>
      </div>

      <div class="main_">
        <h3>房源发布流程</h3>
        <div class="m_flex_box flex_hc flex_vc">
          <div class="flex_v flex_hc flex_vc m_flex w_max">
            <img src="@/assets/img/strictSelection/t1.png" alt="" />
            <p>填写信息</p>
          </div>
          <div class="flex_v flex_hc flex_vc w_min">
            <van-icon name="arrow" size="0.31rem" />
          </div>
          <div class="flex_v flex_hc flex_vc m_flex w_max w_t">
            <img src="@/assets/img/strictSelection/t2.png" alt="" />
            <p>核实房源</p>
          </div>
          <div class="flex_v flex_hc flex_vc w_min">
            <van-icon name="arrow" size="0.31rem" />
          </div>
          <div class="flex_v flex_hc flex_vc m_flex w_max w_t">
            <img src="@/assets/img/strictSelection/t3.png" alt="" />
            <p>选择经纪人</p>
          </div>
          <div class="flex_v flex_hc flex_vc w_min">
            <van-icon name="arrow" size="0.31rem" />
          </div>
          <div class="flex_v flex_hc flex_vc m_flex w_max w_t">
            <img src="@/assets/img/strictSelection/t4.png" alt="" />
            <p>线下带看</p>
          </div>
        </div>
      </div>

      <div class="main_">
        <h3>服务优势</h3>
        <div class="m_flex_box flex_vw flex_jz">
          <div class="inner flex_v  inner_1">
            <h4>国企保障</h4>
            <p>
              为您挑选熟悉<br />
              商圈的经纪人
            </p>
          </div>
          <div class="inner flex_v  inner_2">
            <h4>隐私保护</h4>
            <p>平台隐私信息保护 <br />国企平台安全放心</p>
          </div>
        </div>
      </div>

      <div class="word">
        选择“提交”，我们会为您提供及时的消息推送服务,并将收集
        您的姓名及手机号码用作后续专属服务，届时将有专属客服
        人员与您联系，提供优质而专业的房产资讯服务。
      </div>

      <div style="padding-top:1.6rem"></div>
      <div class="footer m_flex_box flex_vc">
        <div class="btn" @click="onSubmit">
          <p>提交</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topHeader from "@/components/header";
import "swiper/swiper-bundle.css";
export default {
  data() {
    return {
      textColor: "#fff",
      bgColor: "transparent",
      showPickerT: false,
      showPicker: false,
      form: {
        userName: "",
        userCardno: "",
        userPhone: "",
        houseCertificate: "",
      },
    };
  },
  components: {
    topHeader,
  },
  created() {},
  mounted() {},
  methods: {
    onSubmit() {
      if (this.form.userName == "") {
        this.$toast("请输入用户名称");
        return;
      } else if (this.form.userCardno == "") {
        this.$toast("请输入用户身份证号");
        return;
      } else if (this.form.userPhone == "") {
        this.$toast("请输入联系方式");
        return;
      } else if (this.form.houseCertificate == "") {
        this.$toast("请输入房产证号");
        return;
      }
      this.$dialog
        .confirm({
          confirmButtonColor: "#2F72F5",
          title: "提示",
          message:
            "我们会为您提供及时的消息推送服务，并将收集您的姓名及手机号码用作后续的专属服务，届时将有专属客服人员与您电话联系，提供优质而专业的房产资讯服务",
        })
        .then(() => {
          this.$request_yx
            .post("oldnew/clfInfo/add", JSON.stringify(this.form))
            .then((res) => {
              if (res.success) {
                this.$toast(res.message);
              } else {
                this.$toast(res.message);
              }
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style lang="less" scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 0.3rem;
  height: 1.3rem;
  background: #fff;

  .btn {
    width: 90%;
    margin: 0 auto;
    p {
      text-align: center;
      color: #ffffff;
      background: #4582ff;
      padding: 0.22rem 0;
      border-radius: 5px;
    }
  }

  .m_flex {
    img {
      width: 0.44rem;
      height: 0.44rem;
    }
  }
}

.bg_color {
  background-color: #f6f6f6;
}

.top_banner {
  position: relative;
  clear: both;

  img {
    width: 100%;
  }
}

.word {
  width: 7.04rem;
  margin: 0 auto;
  color: #666666;
  font-size: 0.26rem;
  line-height: 0.4rem;
  margin-top: 0.3rem;
  padding: 0 0.1rem;
  box-sizing: border-box;
}

.main {
  width: 7.04rem;
  border-radius: 10px;
  position: relative;
  z-index: 7;
  margin: -3rem auto 0;
  background: #ffffff;
  margin-bottom: 0.2rem;

  h3 {
    padding: 0.2rem 0.3rem 0;
    font-size: 0.32rem;
    font-weight: 900;
  }
  .van-cell--large {
    padding-top: 15px;
    padding-bottom: 15px;
  }
}

.main_ {
  width: 7.04rem;
  border-radius: 10px;
  background: #ffffff;
  margin: 0 auto;
  padding: 0.3rem;
  box-sizing: border-box;
  margin-top: 0.2rem;

  .inner {
    width: 48%;
    font-size: 0.26rem;
    color: #999999;
    padding: 0.2rem 0.6rem 0.2rem 0.3rem;
    box-sizing: border-box;

    img {
      width: 1rem;
      height: 1rem;
    }

    h4 {
      font-size: 0.3rem;
      color: #000;
      font-weight: 700;
      padding: 0.2rem 0 0.1rem 0;
    }

    p {
      text-align: left;
    }
  }

  .inner_1 {
    background-size: 100% 100%;
    background-image: url("../../assets/img/hire/bg_gqbz.png");

    h4 {
      color: #335cac;
    }

    color: #3d5f9e;
  }

  .inner_2 {
    background-size: 100% 100%;
    background-image: url("../../assets/img/hire/bg_jsxy.png");

    h4 {
      color: #7a3d10;
    }

    color: #814721;
  }

  h3 {
    padding: 0.1rem 0 0.3rem 0;
    font-size: 0.32rem;
    font-weight: 900;
  }

  img {
    height: 0.7rem;
    width: 0.7rem;
    padding-bottom: 3px;
  }

  .w_min {
    width: 4%;
  }

  .w_max {
    p {
      font-size: 0.26rem;
      // font-weight: 900;
    }
  }

  .w_t {
    p {
      color: #666666;
    }
  }
}
</style>
